// extracted by mini-css-extract-plugin
export var center = "HeaderLogo-module--center--WMeXx";
export var component = "HeaderLogo-module--component--6fB10";
export var left = "HeaderLogo-module--left--EfjCf";
export var link = "HeaderLogo-module--link--VaXMO";
export var right = "HeaderLogo-module--right--p5pjd";